/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-wrap-multilines */
import { Col, Container, Row } from 'react-bootstrap';
import FeedBack from '../feedBack/FeedBack';
import SocialLinks from '../socialLinks/SocialLinks';
import Sources from '../sources/Sources';
import AccordionComp from '../accordionComp/AccordionComp';
import './articleFooter.css';

// const sourceList = [
//   { text: 'Acid reflux. (n.d.).', link: 'gi.org/topics/acid-reflux/' }
// ];

// const heartBurnPoints = [
//   { text: 'Acid reflux. (n.d.).', link: 'gi.org/topics/acid-reflux/' },
//   { text: 'Antacids. (2019).', link: 'nhs.uk/conditions/antacids/' },
//   {
//     text: 'Clarrett D, et al. (2018). Gastroesophogeal reflux disease.',
//     link: 'ncbi.nlm.nih.gov/pmc/articles/PMC6140167/'
//   },
//   {
//     text: 'Disposal of unused medicines: What you should know. (2020). ',
//     link: 'fda.gov/drugs/safe-disposal-medicines/disposal-unused-medicines-what-you-should-know '
//   },
//   {
//     text: 'Eating, diet, & nutrition for GER & GERD. (2020). ',
//     link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/eating-diet-nutrition'
//   },
//   {
//     text: 'Food and Drug Administration. (2020). FDA requests removal of all ranitidine products (Zantac) from the market [Press release]. ',
//     link: 'fda.gov/news-events/press-announcements/fda-requests-removal-all-ranitidine-products-zantac-market '
//   },
//   {
//     text: 'Heart attack symptom, risk, and recovery. (2021).',
//     link: 'cdc.gov/heartdisease/heart_attack.htm'
//   },
//   {
//     text: 'Heartburn. (2016).',
//     link: 'medlineplus.gov/heartburn.html'
//   },
//   {
//     text: 'Heartburn. (2017).',
//     link: 'familydoctor.org/condition/heartburn'
//   },
//   {
//     text: 'Martinucci I, et al. (2014). Esophageal motility abnormalities in gastroesophageal reflux disease.',
//     link: 'ncbi.nlm.nih.gov/pmc/articles/PMC4023328/'
//   },
//   {
//     text: 'Over-the-counter heartburn treatment. (2021).',
//     link: 'fda.gov/drugs/information-consumers-and-patients-drugs/over-counter-otc-heartburn-treatment'
//   },
//   {
//     text: 'Richter JE, et al. (2019). Presentation and epidemiology of gastroesophageal reflux disease.',
//     link: 'ncbi.nlm.nih.gov/pmc/articles/PMC5797499/'
//   },
//   {
//     text: 'Symptoms and causes of GERD. (2020).',
//     link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/symptoms-causes'
//   },
//   {
//     text: 'Treatment for GER and GERD. (2020).',
//     link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/treatment'
//   },
//   {
//     text: 'Vasquez J. (2015). Heartburn in pregnancy.',
//     link: 'ncbi.nlm.nih.gov/pmc/articles/PMC4562453/'
//   }
// ];

function ArticleFooter(props) {
  const { sourceReviewDate, sourceHeading, sourceDesc, sourceContent } = props;

  return (
    <section className="articleFooter">
      <Container>
        <Row>
          <Col md={4}>
            <Sources
              reviewDate={sourceReviewDate}
              // totalSources="+ 18 sources"
              totalSources={
                <AccordionComp
                  heading={sourceHeading}
                  desc={sourceDesc}
                  content={sourceContent}
                />
              }
            />
          </Col>
          <Col md={4}>
            <SocialLinks />
          </Col>
          <Col md={4}>
            <FeedBack />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ArticleFooter;
